import script from "./EsimCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EsimCard.vue?vue&type=script&setup=true&lang=ts"

import "./EsimCard.vue?vue&type=style&index=0&id=0ecf8f84&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ecf8f84"]])

export default __exports__